import React from 'react';
import styled from 'styled-components/macro';
import { NewModal } from 'lib/components';
import { useFormikContext } from 'formik';
import { useIsMutating } from 'react-query';
import { Button } from 'react-covideo-common';
import { Gap } from 'lib/components/styles/layout';
import { FormikMeetingsValues } from '../../types';
import { useTranslation } from 'react-i18next';

const Content = styled.div`
  width: 600px;
  line-height: 28px;
  color: #272a32;
`;

type Props = {
  handleModalClose: (shouldRefresh?: boolean) => void;
};

export const SendEmailNotificationsMeetingModal = (props: Props) => {
  const { t } = useTranslation();
  const { handleModalClose } = props;
  const { setFieldValue, submitForm } =
    useFormikContext<FormikMeetingsValues>();
  const isSubmitting = useIsMutating();

  return (
    <NewModal
      headerText={t('Live Meeting Update')}
      closeModalOnBackdropOrEscPress={true}
      closeModal={() => {
        setFieldValue('sendEmail', false);
        submitForm();
        handleModalClose();
      }}
      style={{
        content: {
          padding: '32px',
          minWidth: 'auto',
        },
      }}
    >
      <Content>
        {t(
          'Do you want to send email notification about your live meeting update?'
        )}
      </Content>
      <Gap justifyContent='flex-end' m='32px 0 0 0'>
        <Button
          onClick={async () => {
            setFieldValue('sendEmail', false);
            submitForm();
          }}
          disabled={!!isSubmitting}
          text={t("No, Don't Send")}
          variant='secondary'
        />
        <Button
          text={t('Yes, Send')}
          disabled={!!isSubmitting}
          onClick={async () => {
            setFieldValue('sendEmail', true);
            submitForm();
          }}
          variant='destructive'
        />
      </Gap>
    </NewModal>
  );
};
